<template>
   <el-container class="content" style="display: block;">
     <div style="width: 100%;background-color: #000000;z-index: 2;position: relative;" :style="{'width': screenWidth*2+'px','height':screenHeight*2+'px'}">
       <div class="" style="width: 100%;height: 100%;background-color: #000000;position: absolute;" :style="{'width': screenWidth*2+'px','height':screenHeight*2+'px','top':'-'+screenHeight/2+'px','left':'-'+screenWidth/2+'px'}">

         <video autoplay loop muted playsinline style="object-fit: contain;width: 100%;height: 100%;">
           <source src="https://universe.universe.top/guanwang/yuzhou002.webm" type="video/mp4" />
         </video>
       </div>
     </div>




      <div class="" style="width: 80%;height: 80%;object-fit: contain;">

        <div v-if="logint==1" style="object-fit: contain;width: 100%;height: auto;z-index: 1008;position: fixed;left: 40%;" :style="{'width': screenWidth*0.04+'px','height': screenWidth*0.04+'px','top':screenWidth*0.22+'px','left':screenWidth*0.82/2+'px'}">
          <img src="https://images.yoooooo.com/yzzmshouye/erweima.png" style="width: 100%;height: 100%;" >
          <div style="width: 100%;text-align: center;color: #fff;background-color:#212121 ;font-size: 0.5rem;padding: 3px 0px;border-radius: 10px;">下载世间万物</div>
        </div>
        <div v-if="logint==1" style="object-fit: contain;width: 100%;height: auto;z-index: 1008;position: fixed;left: 40%;" :style="{'width': screenWidth*0.04+'px','height': screenWidth*0.04+'px','top':screenWidth*0.22+'px','left':screenWidth*0.55+'px'}">
          <img src="https://images.yoooooo.com/yzzmshouye/erweima.png" style="width: 100%;height: 100%;" >
          <div style="width: 100%;text-align: center;color: #fff;background-color:#212121 ;font-size: 0.5rem;padding: 3px 0px;border-radius: 10px;">下载宇宙场景</div>
        </div>
        <img @click="logins()" src="https://images.yoooooo.com/yzzmshouye/diqiu1.gif"  style="object-fit: contain;width: 100%;height: auto;z-index: 1008;position: fixed;left: 40%;" :style="{'width': screenWidth*0.08+'px','height': screenWidth*0.08+'px','top':screenWidth*0.2+'px','left':screenWidth*0.92/2+'px'}">
        <img @click="logins()" :src="imgt"  style="object-fit: contain;width: 100%;height: auto;z-index: 1008;position: fixed;left: 40%;" :style="{'width': screenWidth*0.08+'px','height': screenWidth*0.08+'px','top':screenWidth*0.12+'px','left':screenWidth*0.92/2+'px'}">


      </div>


     <!-- <div class="beian">


      <a href="http://beian.miit.gov.cn/state/outPortal/loginPortal.action" rel="noreferrer" target="_blank" style="text-decoration:none;color: #fff;background-color: black;">粤ICP备2024237244号@2024 © 宇宙之幂</a>


     </div> -->

    <div style="z-index: 1100;position: absolute;top: 0;" :style="{'width': screenWidth*0.2+'px','top':screenWidth*0.284+'px','left':screenWidth*0.8/2+'px'}" v-if="logint==1">
      <div class="login-container">
          <div class="login-left">
            <div class="tab">
              <span  :class="{active1:loginChose == 'phone'}" @click="change('phone')">验证码登录</span>
              <span  :class="{active1:loginChose == 'password'}" @click="change('password')">密码登录</span>
            </div>
            <div class="desc">你所在地区支持：手机号/邮箱 登录</div>

            <div class="input-group" style="position: relative;">
              <img src="https://images.yoooooo.com/yzzmshouye/86.png" style="position: absolute;height: 60%;top: 20%;left: 5%;"/>
              <input type="text" v-model="phone" placeholder="请输入手机号" />
            </div>

            <div class="verify-group" v-if="loginChose == 'phone'">
              <input type="text" placeholder="请输入验证码" />
              <button @click="sendCaptcha">{{ countdownText() }}</button>
            </div>
            <div class="verify-group" v-if="loginChose == 'password'">
              <input type="text" placeholder="请输入密码" />
            </div>
            <div class="notice">
              注册即同意《用户协议》和《隐私政策》，未满18岁请由监护人陪同使用
            </div>

            <button class="login-button" @click="login()">登录</button>
          </div>

          <div class="login-right">
            <div class="qr-box"><img src="https://images.yoooooo.com/yzzmshouye/erweima.png"  /></div>
            <div class="wechat-text"><img src="https://images.yoooooo.com/yzzmshouye/weixin.png"  />微信扫码登录</div>
          </div>
        </div>
    </div>






   </el-container>







</template>


<script>

  export default {
    data() {
      return {
        logint:2,
        loginChose:'phone',
        bigImg:'',
        list:[],
        screenWidth : window.innerWidth,
        screenHeight : window.innerHeight,
        width:(window.innerWidth*1.1-31*6.5)/30,
        height:(window.innerWidth*1.1-31*6.5)/30,
        isCounting: false,
        countdown: 60,
        phone:'',
        imgt:'https://images.yoooooo.com/UI/AItaocijixienv/gif/rabbit_8.gif'

      };
    },
    mounted() {

      },
      beforeDestroy() {

      },
    created() {

      this.loadList()

      this.getScreen()
      console.log(this.screenWidth,'width')

    },

	methods:{
    login(){
      this.$router.push({ path: '/Xiaoguox' });
    },
    changeT(){
      var jj = 0
      this.interval1 = setInterval(() => {
        if(jj<29){
          jj = jj+1
        }
        this.imgt = this.list[jj]
      }, 3000);
    },
    countdownText() {
      return this.isCounting ? `${this.countdown}s` : '验证码';

    },
    sendCaptcha() {
      if (this.isCounting) return;
      // 这里可以添加发送验证码的逻辑，例如调用 API
      this.sendMsg();

    },
    startCountdown() {
      this.isCounting = true;
      this.countdown = 60;

      this.interval = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.interval);
          this.isCounting = false;
        }
      }, 1000);
    },
    isValidPhone() {
      // 手机号正则表达式（中国大陆手机号）
      const phoneRegex = /^1[3-9]\d{9}$/;

      return phoneRegex.test(this.phone);
    },
    sendMsg(){

      if(!this.isValidPhone()){
        this.msg('请输入正确的手机号码','error');
        return false
      }
      const form = {'phone':this.phone}
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	data:form,
      	url:'https://tossp.yoooooo.com/index.php/index/data/sendMsgsNew'
      })
      .then(res=>{
        if(res.data.code == 200){
          this.startCountdown();
        }
        if(res.data.code == 202){
          this.msg(res.data.data,'error');
        }

      })
      .catch(err=>{

      });
    },

    logins(){
      if(this.logint==2){
        this.logint=1
      }else{
        this.logint=2
      }
    },
    change(t){
      this.loginChose = t
    },
    getScreen() {
      if(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i )){
        window.location.href='http://m.universe.top/'

      }

    },


    loadList(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          name:this.seachName,
          p:this.page,

      	},
      	url:'https://tossp.yoooooo.com/index.php/index/data/loadyzzmShouye'
      })
      .then(res=>{
        this.list = res.data.data;
        this.changeT()


      })
      .catch(err=>{

      });
    },
		msg(msg,type){
			this.$message({
			  message: msg,
			  type: type
			});
		},



	}


  }
</script>
<style>


      .login-container {

        display: flex;
        flex-direction: row;
        background-color: #1a1a1a;
        border-radius: 12px;
        padding: 30px 0px 30px 40px;
        box-shadow: 0 0 12px rgba(0,0,0,0.4);
        max-width: 600px;
        width: 100%;
        gap: 40px;
      }

      .login-left {
        flex: 3;
      }
      .login-right {
        flex: 2;
        background-color: #212121;
        margin: 0px 30px;
      }
      .tab {
        display: flex;
        margin-bottom: 20px;
      }
      .tab span {
        color: #666;
        text-decoration: none;
        margin-right: 16px;
        font-size: 14px;
      }
      .tab span.active1 {
        color: #4e6bf5;
        font-weight: bold;
        border-bottom: 2px solid;
      }
      .desc {
        font-size: 12px;
        margin-bottom: 15px;
        color: #aaa;
      }
      .input-group {
        display: flex;
        margin-bottom: 16px;
      }
      .input-group select,
      .input-group input {
        padding: 10px;
        border: 1px solid #444;
        background: #1a1a1a;
        color: #fff;
        border-radius: 4px;
        font-size: 14px;
        padding-left: 23%;
      }
      .input-group select {
        width: 70px;
        margin-right: 8px;
      }
      .input-group input {
        flex: 1;
      }
      .verify-group {
        display: flex;
        margin-bottom: 16px;
      }
      .verify-group input {
        flex: 1;
        padding: 10px;
        border: 1px solid #444;
        background: #1a1a1a;
        color: #fff;
        border-radius: 4px;
        font-size: 14px;
        margin-right: 10px;
      }
      .verify-group button {
        background: #333;
        color: #fff;
        border: 1px solid #555;
        padding: 10px 14px;
        border-radius: 4px;
        cursor: pointer;
        font-size: 11px;
      }
      .notice {
        font-size: 11px;
        color: #888;
        margin-bottom: 20px;
      }
      .login-button {
        background: #4e6bf5;
        border: none;
        width: 100%;
        padding: 6px;
        color: white;
        border-radius: 6px;
        font-size: 15px;
        cursor: pointer;
      }

      .login-right {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
      .qr-box {
        width: 120px;
        height: 120px;
        border: 4px solid white;
        margin-bottom: 10px;
      }
      .qr-box img{
        width: 120px;
        height: 120px;

      }
      .wechat-text {
        font-size: 12px;
        color: #fff;
        position: relative;
      }
      .wechat-text img{
        position: absolute;
        left: -17px;
        width: 15px;
      }
      input:focus {
        border-color: #4e6bf5;
      }
      /* 响应式：小屏幕（如手机）上下排列 */
      @media screen and (max-width: 768px) {
        .login-container {
          flex-direction: column;
          padding: 20px;
        }
        .login-left {
          margin-right: 0;
        }
        .qr-box {
          width: 100px;
          height: 100px;
        }
      }
</style>
<style>



  .beian {
    position: fixed; /* 定位为固定位置，覆盖整个视窗 */
    color: #616161;
    /* top: 0; */
    left: 42%;
    /* right: 0; */
    bottom: 0;

    z-index: 1000; /* 确保蒙层在其他内容之上 */
  }

  .content{
  	background: #939AA0;
  	width: 100%;
  	height: 100%;
  }
  body {
  overflow-x:hidden;
  overflow-y:hidden;
  }
  .el-scrollbar__wrap{
    background-color: black;
  }







</style>



// WEBPACK FOOTER //
// src/components/main/new/xiaoguo.vue